(() => {
const $973b254601fecd3f$var$$ = jQuery;
const $973b254601fecd3f$var$_window = $973b254601fecd3f$var$$(window);
const $973b254601fecd3f$var$Menu = {
    $dom: {
        container: $973b254601fecd3f$var$$('#site-navigation'),
        container_flv: $973b254601fecd3f$var$$('.header-my-flv-mobile'),
        menu_toggle: $973b254601fecd3f$var$$('.menu-toggle'),
        menu_toggle_flv: $973b254601fecd3f$var$$('.menu-toggle-flv'),
        body: $973b254601fecd3f$var$$('body'),
        menu: undefined,
        menu_flv: undefined,
        links: undefined,
        links_flv: undefined,
        sub_menus: undefined,
        sub_menus_flv: undefined
    },
    vars: {
        activated_screen_resolution: 1023,
        show_arrows_on_desktop: false
    },
    initDom: function() {
        $973b254601fecd3f$var$Menu.$dom.menu = $973b254601fecd3f$var$Menu.$dom.container.find('ul').eq(0);
        $973b254601fecd3f$var$Menu.$dom.links = $973b254601fecd3f$var$Menu.$dom.menu.find('a');
        $973b254601fecd3f$var$Menu.$dom.sub_menus = $973b254601fecd3f$var$Menu.$dom.menu.find('ul');
        $973b254601fecd3f$var$Menu.$dom.menu_flv = $973b254601fecd3f$var$Menu.$dom.container_flv.find('ul').eq(0);
        $973b254601fecd3f$var$Menu.$dom.links_flv = $973b254601fecd3f$var$Menu.$dom.menu_flv.find('a');
        $973b254601fecd3f$var$Menu.$dom.sub_menus_flv = $973b254601fecd3f$var$Menu.$dom.menu_flv.find('ul');
    },
    appendArrows: function() {
        if ($973b254601fecd3f$var$_window.width() <= $973b254601fecd3f$var$Menu.vars.activated_screen_resolution || $973b254601fecd3f$var$Menu.vars.show_arrows_on_desktop) {
            var items_has_children = $973b254601fecd3f$var$Menu.$dom.container.find('li.menu-item-has-children');
            items_has_children.each(function() {
                if ($973b254601fecd3f$var$$(this).find('.arrow-toggle').length > 0) return;
                var $parent = this;
                var $arrow = $973b254601fecd3f$var$$('<span class="arrow-toggle"><svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.69531 16.3964L14.0771 11.0146L8.69531 5.63281" stroke="#1E1E1E" stroke-width="2.15271" stroke-linecap="round" stroke-linejoin="round"/></svg></span>');
                $973b254601fecd3f$var$$(this).prepend($arrow);
                $arrow.on('click', function() {
                    $973b254601fecd3f$var$$($parent).toggleClass('expandeds');
                    $973b254601fecd3f$var$$($parent).find('> .sub-menu').slideToggle(500);
                });
            });
        } else $973b254601fecd3f$var$$('.arrow-toggle').remove();
    },
    appendArrowsFlv: function() {
        if ($973b254601fecd3f$var$_window.width() <= $973b254601fecd3f$var$Menu.vars.activated_screen_resolution || $973b254601fecd3f$var$Menu.vars.show_arrows_on_desktop) {
            var items_has_children = $973b254601fecd3f$var$Menu.$dom.container_flv.find('li.menu-item-has-children');
            items_has_children.each(function() {
                if ($973b254601fecd3f$var$$(this).find('.arrow-toggle').length > 0) return;
                var $parent = this;
                var $arrow = $973b254601fecd3f$var$$('<span class="arrow-toggle"><svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.69531 16.3964L14.0771 11.0146L8.69531 5.63281" stroke="#1E1E1E" stroke-width="2.15271" stroke-linecap="round" stroke-linejoin="round"/></svg></span>');
                $973b254601fecd3f$var$$(this).prepend($arrow);
                $arrow.on('click', function() {
                    $973b254601fecd3f$var$$($parent).toggleClass('expandeds');
                    $973b254601fecd3f$var$$($parent).find('> .sub-menu').slideToggle(500);
                });
            });
        } else $973b254601fecd3f$var$$('.arrow-toggle').remove();
    },
    toggleMenuFlv: function() {
        $973b254601fecd3f$var$Menu.$dom.menu_toggle_flv.on('click', function(e) {
            $973b254601fecd3f$var$Menu.$dom.menu_toggle_flv.toggleClass('is-active');
            $973b254601fecd3f$var$Menu.$dom.body.toggleClass('menu-active-flv');
            $973b254601fecd3f$var$Menu.$dom.container_flv.toggleClass('toggled');
            if ($973b254601fecd3f$var$Menu.$dom.body.hasClass('page-template-homepage-tpl')) $973b254601fecd3f$var$$('html, body').animate({
                scrollTop: $973b254601fecd3f$var$$('#site-header').offset().top
            }, 400);
            e.stopPropagation();
        });
    },
    toggleMenu: function() {
        $973b254601fecd3f$var$Menu.$dom.menu_toggle.on('click', function(e) {
            $973b254601fecd3f$var$Menu.$dom.menu_toggle.toggleClass('is-active');
            $973b254601fecd3f$var$Menu.$dom.body.toggleClass('menu-active');
            $973b254601fecd3f$var$Menu.$dom.container.toggleClass('toggled');
            if ($973b254601fecd3f$var$Menu.$dom.body.hasClass('page-template-homepage-tpl')) $973b254601fecd3f$var$$('html, body').animate({
                scrollTop: $973b254601fecd3f$var$$('#site-header').offset().top
            }, 400);
            e.stopPropagation();
        });
    },
    closeMenu: function() {
        if ($973b254601fecd3f$var$$(this).attr('href') != '#' && $973b254601fecd3f$var$$(this).attr('href') != '') {
            $973b254601fecd3f$var$Menu.$dom.body.removeClass('menu-active');
            $973b254601fecd3f$var$Menu.$dom.body.removeClass('menu-active-flv');
            $973b254601fecd3f$var$Menu.$dom.menu_toggle.removeClass('is-active');
            $973b254601fecd3f$var$Menu.$dom.menu_toggle_flv.removeClass('is-active');
            $973b254601fecd3f$var$Menu.$dom.container.removeClass('toggled');
            $973b254601fecd3f$var$Menu.$dom.container_flv.removeClass('toggled');
        }
    },
    bindScrollResize: function() {
        $973b254601fecd3f$var$_window.on('resize', function() {
            $973b254601fecd3f$var$Menu.appendArrows();
            $973b254601fecd3f$var$Menu.appendArrowsFlv();
        });
    },
    bindClicks: function() {
        $973b254601fecd3f$var$$(document).on('click', $973b254601fecd3f$var$Menu.closeMenu);
        $973b254601fecd3f$var$Menu.$dom.links.on('click', $973b254601fecd3f$var$Menu.closeMenu);
        $973b254601fecd3f$var$Menu.$dom.links_flv.on('click', $973b254601fecd3f$var$Menu.closeMenu);
        $973b254601fecd3f$var$Menu.toggleMenu();
        $973b254601fecd3f$var$Menu.toggleMenuFlv();
        $973b254601fecd3f$var$Menu.$dom.container.find('> div').click(function(e) {
            e.stopPropagation();
        });
        $973b254601fecd3f$var$Menu.$dom.container_flv.find('> div').click(function(e) {
            e.stopPropagation();
        });
    },
    init: function() {
        $973b254601fecd3f$var$Menu.initDom();
        $973b254601fecd3f$var$Menu.appendArrows();
        $973b254601fecd3f$var$Menu.appendArrowsFlv();
        $973b254601fecd3f$var$Menu.bindClicks();
        $973b254601fecd3f$var$Menu.bindScrollResize();
    }
};
var $973b254601fecd3f$export$2e2bcd8739ae039 = $973b254601fecd3f$var$Menu;


const $cb4d446bec07f967$var$$ = jQuery;
const $cb4d446bec07f967$var$_window = $cb4d446bec07f967$var$$(window);
const $cb4d446bec07f967$var$Slider = {
    init: ()=>{
        $cb4d446bec07f967$var$$('.section-intro--slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: $cb4d446bec07f967$var$$('.section-intro--slider-prev'),
            nextArrow: $cb4d446bec07f967$var$$('.section-intro--slider-next'),
            dots: true,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 800,
            fade: true,
            pauseOnFocus: true,
            responsive: [
                {
                    breakpoint: 640,
                    settings: {
                        arrows: false,
                        prevArrow: false,
                        nextArrow: false
                    }
                }
            ]
        });
    }
};
var $cb4d446bec07f967$export$2e2bcd8739ae039 = $cb4d446bec07f967$var$Slider;


const $cb6de554e11ef79b$var$$ = jQuery;
const $cb6de554e11ef79b$var$Theme = {
    dom: {
        shareLink: $cb6de554e11ef79b$var$$(".share-buttons a"),
        smoothScrollLinks: $cb6de554e11ef79b$var$$('a[href*="#"]')
    },
    preventEmptyLink: function() {
        $cb6de554e11ef79b$var$$('a[href="#"], a[href=""]').on("click", function(e) {
            e.preventDefault();
        });
    },
    /**************************************************
    * Share links
    **************************************************/ share: function() {
        $cb6de554e11ef79b$var$$(".share-buttons a").on("click", function(e) {
            if (!$cb6de554e11ef79b$var$$(this).hasClass("btn-email")) {
                e.preventDefault();
                $cb6de554e11ef79b$var$Theme.PopupCenter($cb6de554e11ef79b$var$$(this).attr("href"), $cb6de554e11ef79b$var$$(this).attr("title"), 500, 300);
            }
        });
    },
    /**************************************************
    * Share links popup
    **************************************************/ PopupCenter: function(url, title, w, h) {
        // Fixes dual-screen position                         Most browsers      Firefox
        var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
        var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;
        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
        var left = width / 2 - w / 2 + dualScreenLeft;
        var top = height / 2 - h / 2 + dualScreenTop;
        var newWindow = window.open(url, title, "scrollbars=yes, width=" + w + ", height=" + h + ", top=" + top + ", left=" + left);
        // Puts focus on the newWindow
        if (window.focus) newWindow.focus();
    },
    /**************************************************
    * Smooth scroll
    ***************************************************/ smooth_scroll: function() {
        $cb6de554e11ef79b$var$Theme.dom.smoothScrollLinks// Remove links that don't actually link to anything
        .not('[href="#"]').not('[href="#0"]').click(function(event) {
            // On-page links
            if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
                // Figure out element to scroll to
                var target = $cb6de554e11ef79b$var$$(this.hash);
                target = target.length ? target : $cb6de554e11ef79b$var$$("[name=" + this.hash.slice(1) + "]");
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $cb6de554e11ef79b$var$$("html, body").animate({
                        scrollTop: target.offset().top
                    }, 1000, function() {
                        // Callback after animation
                        // Must change focus!
                        var $target = $cb6de554e11ef79b$var$$(target);
                        $target.focus();
                        if ($target.is(":focus")) // Checking if the target was focused
                        return false;
                        else {
                            $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                        }
                    });
                }
            }
        });
    },
    /**************************************************
    * Fix Height on smaller devices
    **************************************************/ fix_mobile_height: function() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        window.addEventListener('resize', ()=>{
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        });
    },
    /**************************************************
    * Initial all theme functions
    **************************************************/ init: function() {
        $cb6de554e11ef79b$var$Theme.share();
        $cb6de554e11ef79b$var$Theme.smooth_scroll();
        $cb6de554e11ef79b$var$Theme.fix_mobile_height();
        $cb6de554e11ef79b$var$Theme.preventEmptyLink();
    }
};
var $cb6de554e11ef79b$export$2e2bcd8739ae039 = $cb6de554e11ef79b$var$Theme;


const $ee595bbced94e3de$var$$ = jQuery;
const $ee595bbced94e3de$var$Accordion = {
    init: ()=>{
        $ee595bbced94e3de$var$$(".accordion-title").on("click", function() {
            const parent = $ee595bbced94e3de$var$$(this).parent();
            const content = parent.find(">.accordion-content");
            if (parent && parent.length > 0 && content && content.length > 0) {
                if (parent.hasClass("active")) {
                    content.slideUp("0.4s");
                    parent.removeClass("active");
                } else {
                    content.slideDown("0.4s");
                    parent.addClass("active");
                }
            }
        });
    }
};
var $ee595bbced94e3de$export$2e2bcd8739ae039 = $ee595bbced94e3de$var$Accordion;


const $98105b4090742ab5$var$$ = jQuery;
const $98105b4090742ab5$var$configDatePicker = {
    locale: $98105b4090742ab5$var$$('html').attr('lang') == 'sr-RS' ? 'sr' : 'en',
    disableMobile: "true"
};
const $98105b4090742ab5$var$Form = {
    addIconToDatepicker: ($wrapper)=>{
        const $input = $wrapper.find('input').first();
        // Prevent duplicate initialization
        if (!$input.length || $input[0]._flatpickr) return;
        // Add calendar trigger if it doesn't exist
        if (!$wrapper.find('.mbn-datepicker-trigger').length) $wrapper.append(`
                    <span
                        class="mbn-datepicker-trigger"
                        aria-label="Open calendar"
                    >
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.3333 1.66675V5.00008M6.66667 1.66675V5.00008M2.5 8.33341H17.5M4.16667 3.33341H15.8333C16.7538 3.33341 17.5 4.07961 17.5 5.00008V16.6667C17.5 17.5872 16.7538 18.3334 15.8333 18.3334H4.16667C3.24619 18.3334 2.5 17.5872 2.5 16.6667V5.00008C2.5 4.07961 3.24619 3.33341 4.16667 3.33341Z" stroke="#757575" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

                    </span>
                `);
        // Initialize Flatpickr
        const flatpickrInstance = $input.flatpickr($98105b4090742ab5$var$configDatePicker);
        // Open calendar on icon click
        $wrapper.find('.mbn-datepicker-trigger').off('click.flatpickr').on('click.flatpickr', function() {
            flatpickrInstance.open();
        });
    },
    newInitFlatpickr: ()=>{
        const inputs = $98105b4090742ab5$var$$('.mbn-datepicker-wrapper input');
        inputs.each(function() {
            const $wrapper = $98105b4090742ab5$var$$(this).parent();
            $98105b4090742ab5$var$Form.addIconToDatepicker($wrapper);
        });
    },
    showFileName: ()=>{
        const inputs = $98105b4090742ab5$var$$('input[type="file"]');
        inputs.on('change', function() {
            const $this = $98105b4090742ab5$var$$(this);
            const parent = $this.parent();
            const choosenFile = parent.find('.chosen-file');
            if (this.files && this.files.length > 0) {
                console.log(this.files[0].name);
                console.log(this.files);
                let names = [];
                for(let index = 0; index < this.files.length; index++){
                    const fileData = this.files[index];
                    names.push(fileData.name);
                }
                parent.addClass('has-files');
                if (choosenFile.length > 0) $98105b4090742ab5$var$$(choosenFile).text(names.join(', '));
                else parent.append('<span class="chosen-file">' + names.join(', ') + '</span>');
            } else {
                parent.removeClass('has-files');
                const choosenFile = parent.find('.chosen-file');
                choosenFile.text('');
            }
        });
    },
    addNewItem: ()=>{
        $98105b4090742ab5$var$$('.add-new-item').on('click', function(e) {
            e.preventDefault();
            const $this = $98105b4090742ab5$var$$(this);
            const parent = $this.parent();
            const container = parent.prev();
            const items = container.find('.gfield_list_group');
            const lastItem = items.last();
            const addBtn = lastItem.find('.add_list_item');
            if (addBtn) addBtn.trigger('click');
        });
    },
    init: ()=>{
        $98105b4090742ab5$var$Form.addNewItem();
        // Date picker
        $98105b4090742ab5$var$Form.newInitFlatpickr();
        gform.addAction('gform_list_post_item_add', function(item, container) {
            // 'item' is the jQuery object of the new <tr> row
            // 'container' is the jQuery object of the <table>
            const newFields = $98105b4090742ab5$var$$(item).find('.mbn-datepicker-wrapper input');
            newFields.each(function() {
                const $wrapper = $98105b4090742ab5$var$$(this).parent();
                $98105b4090742ab5$var$Form.addIconToDatepicker($wrapper);
            });
        });
        // show file name in field
        $98105b4090742ab5$var$Form.showFileName();
    }
};
var $98105b4090742ab5$export$2e2bcd8739ae039 = $98105b4090742ab5$var$Form;


(0, $973b254601fecd3f$export$2e2bcd8739ae039).init();
(0, $cb6de554e11ef79b$export$2e2bcd8739ae039).init();
(0, $cb4d446bec07f967$export$2e2bcd8739ae039).init();
// Intro.init();
(0, $ee595bbced94e3de$export$2e2bcd8739ae039).init();
(0, $98105b4090742ab5$export$2e2bcd8739ae039).init();

})();
//# sourceMappingURL=main.js.map
